import { render, staticRenderFns } from "./ChooseWinery.vue?vue&type=template&id=63d38316&scoped=true&"
import script from "./ChooseWinery.vue?vue&type=script&lang=js&"
export * from "./ChooseWinery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d38316",
  null
  
)

export default component.exports